import React, { useEffect, useState } from "react";
import { getRequest, postRequest } from "../../globalhelper/helper";
import FormBasicInput from "../CI/FormBasicInput";
import "../CI/LARPopup.css";
import FetchEmail from "./FetchEmail";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../redux/Common/commonActions";
import { CSVLink } from "react-csv";

const InboxInitialInput = () => {
  let dispatch = useDispatch();
  const [mainScreen, showMainScreen] = useState(false);
  const [searchScreen, showSearchScreen] = useState(true);
  const [resultArray, setResultArray] = useState([]);
  const [message, setMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [formData, setFormData] = useState({
    company: "",
    fromDate: "",
    toDate: "",
  });
  const [companyName, setCompanyName] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [orgid, setOrgid] = useState("");

  useEffect(() => {
    let isMounted = true;
    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then((response) => {
        if (!isMounted) return;
        console.log(response.res.data);
        const responseData = response.res.data;
        const orgname = responseData
          .map((item) => item.orgname || item?.["Organization Name"])
          .filter((name) => name !== undefined && name !== null);
        setCompanyDetails(responseData);
        setCompanyName(orgname);
        if (orgname.length === 1) {
          setFormData((prev) => {
            return { ...prev, company: orgname[0] };
          });
        }
      })
      .catch((err) => {
        if (!isMounted) return;
        console.log(err);
      });
    var currentDate = moment();
    var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
    var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
    setFormData((prev) => {
      return { ...prev, fromDate: firstDay, toDate: lastDay };
    });

    return () => {
      isMounted = false;
    };
  }, []);

  const handleChange = (name, value) => {
    setFormData((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleReset = () => {
    setFormData({
      company: "",
    });
    var currentDate = moment();
    var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
    var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
    setFormData((prev) => {
      return { ...prev, fromDate: firstDay, toDate: lastDay };
    });
    setResultArray([]);
  };

  const getDateList = (startDate, endDate) => {
    const dateList = [];

    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      const dateString = currentDate.toISOString().split("T")[0];
      dateList.push(dateString);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dateList;
  };

  const getDateListOldFormat = (startDate, endDate) => {
    const dates = [];
    let currentDate = startDate;

    while (currentDate <= endDate) {
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1; // Months are 0-based
      const day = currentDate.getDate();

      const formattedDate = `${year}-${month}-${day}`;
      dates.push(formattedDate);

      // Increment currentDate for the next iteration
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  };

  const formatDates = (dateArray) => {
    const formattedDates = [];

    dateArray.forEach((inputDate) => {
      const dateParts = inputDate.split("-");
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      const day = parseInt(dateParts[2], 10);

      const date = new Date(year, month, day);

      const fday = String(date.getDate()).padStart(2, "0");
      const fmonth = String(date.getMonth() + 1).padStart(2, "0");
      const fyear = date.getFullYear();

      const formatDate = `${fday}-${fmonth}-${fyear}`;

      formattedDates.push(formatDate);
    });

    return formattedDates;
  };

  const formatDatesOldFormat = (dateArray) => {
    const formattedDates = [];

    dateArray.forEach((inputDate) => {
      const dateParts = inputDate.split("-");
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      const day = parseInt(dateParts[2], 10);

      const date = new Date(year, month, day);

      const fday = String(date.getDate());
      const fmonth = String(date.getMonth() + 1);
      const fyear = date.getFullYear();

      const formatDate = `${fday}-${fmonth}-${fyear}`;

      formattedDates.push(formatDate);
    });

    return formattedDates;
  };

  const handleSubmit = (RunBackGround = false) => {
    if (!RunBackGround) dispatch(showLoader());

    showMainScreen(false);
    const dateList = getDateList(
      new Date(formData.fromDate),
      new Date(formData.toDate),
    );

    const dateListOld = getDateListOldFormat(
      new Date(formData.fromDate),
      new Date(formData.toDate),
    );

    console.log(dateListOld);

    const formatDate = formatDates(dateList);

    const formatDateOld = formatDatesOldFormat(dateListOld);

    const finalFormat = formatDate.concat(formatDateOld);

    const id = companyDetails.filter(
      (item) => item.orgname === formData.company || item?.["Organization Name"] === formData.company,
    );

    const companyid = id.map((item) => item.orgid || item?.["Organization ID"]);

    if (finalFormat && formData.company) {
      postRequest(`api/dashboard/inboxFilter`, {
        item: finalFormat,
        companies: companyid[0],
      })
        .then((response) => {
          console.log(response.res.data);
          if (response.res.data.length) {
            setOrgid(companyid[0]);
            let sortedData = response.res.data.sort((a, b) => {
              return new Date(b.Date) - new Date(a.Date);
            });
            setResultArray(sortedData);
            showMainScreen(true);
          } else {
            console.log("No Records to display");

            setMessage(true);
            setErrorMessage("No Records to display");
            dispatch(hideLoader());
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      console.log(finalFormat || formData.company);

      setMessage(true);
      setErrorMessage("Please select all the required fields");
    }
  };

  return (
    <>
      {searchScreen && (
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">
              Please select the date range to view Reports
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container gap={2} spacing={3}>
              <Grid item xs={1} sm={2} md={3}>
                <Autocomplete
                  options={companyName || []}
                  value={formData.company}
                  onChange={(e, newValue) => handleChange("company", newValue)}
                  fullWidth
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Company Name"
                      variant="outlined"
                      size="small"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1} sm={2} md={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="ForPrdFrom"
                    value={formData.fromDate}
                    views={["day", "month", "year"]}
                    onChange={(newValue) => {
                      handleChange("fromDate", newValue.format("YYYY-MM-DD"));
                    }}
                    renderInput={(params) => (
                      <TextField fullWidth size="small" {...params} />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={1} sm={2} md={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="ForPrdTo"
                    value={formData.toDate}
                    views={["day", "month", "year"]}
                    onChange={(newValue) => {
                      handleChange("toDate", newValue.format("YYYY-MM-DD"));
                    }}
                    renderInput={(params) => (
                      <TextField fullWidth size="small" {...params} />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleReset}
                  style={{ marginLeft: "10px" }}
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      )}

      {resultArray.length === 0 && message && (
        <Box style={{ margin: "auto" }}>
          <Alert severity="warning">
            <AlertTitle>No Data Found</AlertTitle>
            There is no data to display at the moment.
          </Alert>
        </Box>
      )}
      {mainScreen && (
        <FetchEmail
          handleSubmit={handleSubmit}
          resultArray={resultArray}
          showMainScreen={showMainScreen}
          orgid={orgid}
          companyName={formData.company}
          showSearchScreen={showSearchScreen}
        />
      )}
    </>
  );
};

export default InboxInitialInput;
